<div id="historyRequestErrorDialog" class="modal modal-lg modal-dialog fade in" role="dialog" style="display: none;" appDraggable dragTarget="#historyRequestErrorDialog" dragHandle="#historyRequestErrorDialogHeader">
  <div class="modal-content">
    <div class="modal-header" id="historyRequestErrorDialogHeader">
      HISTORY QUERY ERROR
    </div>

    <div class="modal-body internal-well">
      <div>{{ historyError }}</div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="hide()"><i class="fa fa-ban" aria-hidden="true"></i> OK</button>
    </div>
  </div>
</div>

